import { FormTab } from '@kirz/mui-admin';
import React from 'react';

import { CallsTable } from 'components/CallsTable';

export default function CallsTab(props: { clientId: number }) {
  const { clientId } = props;

  return (
    <FormTab tab="calls" grid={false} sx={{ flexGrow: 1, display: 'flex' }}>
      {(isVisible) =>
        !isVisible ? null : (
          <CallsTable
            id="client-calls-table"
            sx={{ mx: -2, borderColor: 'transparent' }}
            filterColumns={(columns) =>
              columns.filter((column) => column.field !== 'clientByPhone')
            }
            selectProps={{
              filter: { clientByPhone: { clientId: { _eq: clientId } } },
            }}
          />
        )
      }
    </FormTab>
  );
}
